document.documentElement.classList.add('nh-js');

const revealItems = document.querySelectorAll('[data-nh-reveal]');

if ('IntersectionObserver' in window && revealItems.length > 0) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('nh-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.18 }
  );

  revealItems.forEach((item) => observer.observe(item));
} else {
  revealItems.forEach((item) => item.classList.add('nh-revealed'));
}

document.querySelectorAll('[data-nh-tabs]').forEach((tabs) => {
  const buttons = tabs.querySelectorAll('[data-nh-tab]');
  const panels = tabs.querySelectorAll('[data-nh-panel]');

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const target = button.getAttribute('data-nh-tab');

      buttons.forEach((item) => {
        item.setAttribute('aria-selected', item === button ? 'true' : 'false');
      });

      panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.getAttribute('data-nh-panel') === target);
      });
    });
  });
});

document.querySelectorAll('.nh-product-form').forEach((form) => {
  const select = form.querySelector('.nh-variant-select');
  const buttons = form.querySelectorAll('[data-nh-variant-id]');
  const price = document.querySelector('[data-nh-product-price]');

  if (!select || buttons.length === 0) return;

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      select.value = button.getAttribute('data-nh-variant-id');
      select.dispatchEvent(new Event('change', { bubbles: true }));

      buttons.forEach((item) => item.classList.toggle('is-active', item === button));

      if (price && button.dataset.nhVariantPrice) {
        price.textContent = button.dataset.nhVariantPrice;
      }

      const submit = form.querySelector('button[name="add"]');
      if (submit && button.dataset.nhVariantPrice) {
        submit.textContent = `Add to cart - ${button.dataset.nhVariantPrice}`;
      }
    });
  });
});
